export default "__VITE_ASSET__BFukO9id__"